import { z } from 'zod/v4';

import { purchaseOrderSchema } from './purchase-order.schema';

export const purchaseOrderHistoryItemSchema = z.object({
  product: z.object({
    productId: z.number().min(1),
    name: z.string().min(1),
  }),
  purchaseOrders: z.array(purchaseOrderSchema),
});

export type PurchaseOrderHistoryItem = z.infer<
  typeof purchaseOrderHistoryItemSchema
>;
